<section class="container">
  <h6>IPOC</h6>
  <div class="alert alert-info container" *ngIf="!trocasIPOC || !trocasIPOC.length; else listaIPOCS">
    Não existem IPOCs para a operação informada
  </div>
  <bn-paginacao [total]="countTrocasIpoc" [tamanhoPagina]="atributosPaginacaoAbaTrocaIpoc.pageSize"
    [numPagina]="atributosPaginacaoAbaTrocaIpoc.page" [opcoesTamanhoPagina]="opcoesPaginacaoTrocaIpoc">
    <ng-template #listaIPOCS>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-dataBase" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataBase'"
                  [nomeAtributoExibicao]="'Mês Referência'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-numeroIpocNovo'" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'numeroIpocNovo'"
                  [nomeAtributoExibicao]="'IPOC Novo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

                <th id="col-tipoIPOC'" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoIPOC'" [nomeAtributoExibicao]="'Tipo de IPOC'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-tipoAcao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'tipoAcao'"
                  [nomeAtributoExibicao]="'Tipo de Ação'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-dataEnvioScrBc" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvioScrBc'"
                  [nomeAtributoExibicao]="'Dt de Env SCR pelo AF'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-dataUltimaAtualizacao" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataUltimaAtualizacao'"
                  [nomeAtributoExibicao]="'Dt de Env no Portal'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th id="col-dataDesativacao" scope="col" *ngIf="opcaoMostrarTodosIpocs">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataDesativacao'"
                  [nomeAtributoExibicao]="'Dt Desativacao'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaIpoc" [class.stroke]="item.dataDesativacao">
              <td>{{item.dataBase +'-01'| date: 'MM/yyyy' }}</td>
              <td>{{item.numeroIpocNovo}}</td>
              <td>{{item.tipoIPOC}}</td>
              <td>{{retornaLabelTipoAcao(item.tipoAcao)}}</td>
              <td>{{item.dataEnvioScrBc}}</td>
              <td>{{item.dataUltimaAtualizacao}}</td>
              <td *ngIf="opcaoMostrarTodosIpocs">{{item.dataDesativacao}}</td>
              <td *ngIf="permissaoEdicao && item.dataDesativacao == null" class="text-center" id=col-acoes>
                <a href="javascript:void(0)" (click)="desativarIPOC(item)">
                  <i class="fa fa-trash cursor-pointer" placement="left-top" ngbTooltip="Desativar IPOC"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </bn-paginacao>
  </section>

<br>

<section class="container" *ngIf="!isAgente">
  <h6>Tempo de atraso</h6>
  <div class="alert alert-info container" *ngIf="!diasAtraso || !diasAtraso.length; else listaAtrasos">
    Não existem dias de atraso para a operação informada
  </div>
  <ng-template #listaAtrasos>
    <bn-paginacao [total]="countAtraso" [tamanhoPagina]="atributosPaginacaoAbaDiasAtraso.pageSize"
      [numPagina]="atributosPaginacaoAbaDiasAtraso.page" [opcoesTamanhoPagina]="opcoesPaginacaoDiasAtraso" (aoMudar)="mudancaPaginaDiasAtraso($event)">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-dataBase'" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataBase'"
                  [nomeAtributoExibicao]="'Data Base'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-numeroDiasAtraso" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'numeroDiasAtraso'"
                  [nomeAtributoExibicao]="'Dias de Atraso'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaAtraso">
              <td>{{item.dataBase}}</td>
              <td>{{item.numeroDiasAtraso}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </ng-template>
</section>
